import React, { useRef, useEffect, useContext } from 'react';

// Components
import Hero from '../../../components/advanced/hero/Hero';
import ProfileBadge from '../../../components/advanced/profileBadge/ProfileBadge';
import Kyc from './components/kyc/Kyc';
import Tooltip from '../../../components/advanced/tooltip/Tooltip';

// Libraries
import { Container, MagicModal } from '@hybris-software/ui-kit';
import { PermissionRoute, useUser } from '@hybris-software/use-auth';
import { useNavigate } from 'react-router-dom';
import useQuery from '@hybris-software/use-query/dist/Hooks/useQuery';

// Svgs
import Copy from '../../../assets/svgs/Copy';

// Hooks
import useText from '../../../hooks/useText';

// Contexts
import { RoutesContext } from '../../../contexts/RoutesContext';

// Data
import config from '../../../data/config';
import endpoints from '../../../data/endpoints';

// Utils
import dispatcher from '../../../utils/dispatcher';

// Styles
import Style from './KycView.module.css';
import { accountType } from '../../../data/constants';

const KycView = () => {
	// Hooks
	const copy = useText('copyTooltip');
	const texts = useText('kycView');
	const { userInfo } = useUser();
	const navigate = useNavigate();
	// Refs
	const modalRef = useRef();
	// Contexts
	const { paths } = useContext(RoutesContext);

	useEffect(() => {
		document.title = `${config.PLATFORM_NAME} | ${
			userInfo?.accountType === accountType.PERSONAL
				? texts?.pageTitle
				: texts?.pageTitleCompany
		}`;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Quires
	const getKYCStatusAPI = useQuery({
		url: endpoints.kyc.CHECK_STATUS,
		method: 'GET',
		executeImmediately: true,
		onSuccess: (response) => {},
		onError: (error) => {},
	});

	return (
		<PermissionRoute
			firstApiLoading={getKYCStatusAPI.isLoading}
			//   loader={<Loader />}
			minimumLoadingTime={500}
			forLoggedUser={true}
			unAuthorizedAction={() => {
				navigate(paths.auth.login);
			}}
			permissionController={(response) => {
				dispatcher(response.data, navigate, paths);
				return true;
			}}
		>
			<MagicModal ref={modalRef} />

			<Hero>
				<Container>
					<div className={Style.header}>
						<h3 className={Style.title}>{texts?.title}</h3>
						<div className={Style.referral}>
							<div className={Style.referralText}>
								{texts?.cardReferral}{' '}
								{`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'}
							</div>

							<Tooltip
								valueToCopy={
									`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'
								}
								copyIcon={<Copy />}
								textCopy={copy?.copied}
							/>
						</div>
					</div>

					<ProfileBadge modalRef={modalRef} />
				</Container>
			</Hero>

			<Container>
				<Kyc getKYCStatusAPI={getKYCStatusAPI} />
			</Container>
		</PermissionRoute>
	);
};

export default KycView;
